import React from 'react'
import { Heading } from '@scentregroup/ui'
import { IVisualGuideInfo } from '../../lib/use-visual-guide-context'
import Dialog from '../dialog'
import style from './index.module.scss'
import Markdown from '@scentregroup/shared/components/markdown'
import { Stack } from '@hub/stack'

export interface IVisualGuideDialog {
  isOpen: boolean
  info: IVisualGuideInfo
  retailerSizeGuide?: string
  defaultSizeGuide?: string | null
  onDismiss: () => void
}

const VisualGuideDialog: React.FunctionComponent<
  React.PropsWithChildren<IVisualGuideDialog>
> = ({ isOpen, info, retailerSizeGuide, defaultSizeGuide, onDismiss }) => {
  return (
    <Dialog
      isOpen={isOpen}
      onDismissButtonClick={onDismiss}
      a11y={{ labelledby: info.optionId }}
    >
      <Heading type="small" className={style.heading}>
        {info.name}
      </Heading>
      <Stack
        shouldWrapChildren={false}
        sx={{
          height: '70vh',
          overflow: 'scroll',
        }}
      >
        <Markdown content={retailerSizeGuide || defaultSizeGuide} />
      </Stack>
    </Dialog>
  )
}

export default VisualGuideDialog
